import { Breadcrumbs, Link, Typography } from "@mui/material";
import React from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { routes } from "../../configuration/routes";

function LinkRouter(props) {
  return <Link {...props} component={RouterLink} />;
}

function BreadCrumbs({ pageTitle, pathTitle, previousRouteId, previousRouteIdDepth = 1, rightSection = null }) {
  const buildBreadcrumbNameMap = (routes, parentPath = "") => {
    return routes.reduce((breadcrumbNameMap, route) => {
      const path = `${parentPath}${route.path ? "/" + route.path : ""}`.toLocaleLowerCase();

      if (route.title) {
        breadcrumbNameMap[path] = route.title;
      }

      if (route.children) {
        const childBreadcrumbNameMap = buildBreadcrumbNameMap(route.children, path);
        Object.assign(breadcrumbNameMap, childBreadcrumbNameMap);
      }

      return breadcrumbNameMap;
    }, {});
  };

  const breadcrumbNameMap = buildBreadcrumbNameMap(routes);
  const location = useLocation();
  const pathnames = location.pathname.split("/").slice(1);
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <Typography fontSize={"20px"} fontWeight={"bold"}>
          {pageTitle ?? breadcrumbNameMap[location.pathname.toLocaleLowerCase()]}
        </Typography>
        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: "14px", fontWeight: "medium" }}>
          <LinkRouter underline="hover" color="#7CA7AD" to="/admin">
            Home
          </LinkRouter>
          {pathnames.map((value, index) => {
            if(index === 0) return null // Skip the first // admin
            const last = index === pathnames.length - 1;
            const to = `/${pathnames.slice(0, index + 1).join("/")}`.toLocaleLowerCase();

            const isId = previousRouteId ? index === ((pathnames.length - 1) - previousRouteIdDepth) : false

            return last ? (
              <div key={to} style={{ color: "black" }}>
                {pathTitle ?? breadcrumbNameMap[to]}
              </div>
            ) : (
              <LinkRouter underline="hover" color="#7CA7AD" to={`${to}${isId ? '?id='+previousRouteId : ''}`} key={to}>
                {breadcrumbNameMap[to]}
              </LinkRouter>
            );
          })}
        </Breadcrumbs>
      </div>
      {rightSection}
    </div>
  );
}

export default BreadCrumbs;
